import type { ConsumablesModeType } from '@/types/consumables'
import { dayjs } from 'element-plus'

export type TreasuryItemType = {
  name: string
  desc: string
  key: ConsumablesModeType
  show?: (value: number) => boolean
}
export const treasuryInfoList: TreasuryItemType[] = [
  {
    name: '🔨 强化保护券',
    desc: '强化时使用，可保护装备免受失败降级',
    key: 'reinforceProtect',
  },
  {
    name: '🎇 升星石',
    desc: '用于替代传说品质及以下的装备进行升星',
    key: 'riseStarStone',
  },
  {
    name: '🎆 远古石',
    desc: '用于研究所-神兵处打造远古品质装备',
    key: 'antiquityStone',
  },
  {
    name: '📌 融合稳定剂',
    desc: '在融合宠物时使用，融合后代的战斗评分不会低于选中魔物的最大战斗评分',
    key: 'fusionStabilizer',
  },
  {
    name: '🎫 高级祈福券',
    desc: '用于觉醒殿堂中的高级祈福',
    key: 'runeBlessCoupon',
  },
  {
    name: '✨ 符石碎星',
    desc: '用于觉醒殿堂中合成符石',
    key: 'runeStar',
  },
  {
    name: '🔷 裂隙晶石',
    desc: '用于秘术坊中附魔装备',
    key: 'crackStone',
  },
  {
    name: '📜 裂隙挑战券',
    desc: '用于额外挑战虚空裂隙',
    key: 'crackFight',
  },
  {
    name: '🩸 附魔增强剂',
    desc: '附魔时使用，可提升附魔保底加成',
    key: 'enchantEnhance',
  },
  {
    name: '🧬 远古之魂',
    desc: '用于魔物牧场中将传说魔物进化为远古魔物',
    key: 'antiquitySoul',
  },
  {
    name: '🟠 锻造石',
    desc: '用于秘术坊中的高阶强化',
    key: 'forgeStone',
  },
  {
    name: '🟣 潜能石',
    desc: '用于魔物牧场中激发魔物的潜能',
    key: 'potentialityStone',
  },
  {
    name: '🟡 精造石',
    desc: '用于暗金工坊中的精造',
    key: 'refineStone',
  },
  {
    name: '♋ 刻印券',
    desc: '用于暗金工坊中的刻印，使用时刻印不消耗金币',
    key: 'engraveCoupon',
  },
  {
    name: '🍔 荒野补给包',
    desc: '大荒野中使用，可获得 5点体力',
    key: 'wildSupply',
  },
  {
    name: '🔆 奥秘香薰',
    desc: '持有时，当获得鎏金神殿奖励，将额外获得 1件神话暗金装备',
    key: 'mysteryAromatherapy',
  },
  {
    name: '🔯 奥秘锻造石',
    desc: '合成神话暗金时使用，可必定获得 4超限神话装备',
    key: 'mysteryStone',
  },
  {
    name: '✨ 圣物碎星',
    desc: '用于圣物藏馆中合成圣物',
    key: 'relicStar',
  },
  {
    name: '🧩 圣物藏宝图',
    desc: '用于圣物藏馆中寻宝',
    key: 'relicTreasureMap',
  },
  {
    name: '⚪ 提纯石',
    desc: '用于提升暗金装备的刻印属性评分',
    key: 'purifyStone',
  },
  {
    name: '💥 辉耀之石',
    desc: '用于合成指定满分符石',
    key: 'shineBrightlyStone',
  },
  {
    name: '🟨 至臻精造石',
    desc: '用于至臻工坊中的精造',
    key: 'supremeRefineStone',
  },
  {
    name: '🟩 技能升级石',
    desc: '用于魔法工坊中提升技能等级，每个可增加 10经验',
    key: 'skillUpgradeStone',
  },
  {
    name: '🧾 启迪卷轴',
    desc: '用于二觉殿堂中启迪技能',
    key: 'skillEnlightenmentScroll',
  },
  {
    name: '🔸 秘技残页',
    desc: '用于魔法工坊中合成技能',
    key: 'antiquitySkillPageFragment',
  },

  {
    name: '♊ 至臻刻印券',
    desc: '用于至臻工坊中的刻印，使用时刻印不消耗金币',
    key: 'supremeEngraveCoupon',
  },
  {
    name: '🍄 秘藏洞窟挑战券',
    desc: '用于挑战秘藏洞窟，2026-03-08 过期',
    key: 'secretCaveFight',
    show: () => dayjs().isBefore('2026-03-08', 'day'),
  },
  {
    name: '💲 活动积分',
    desc: '用于庆典活动中兑换物品，2026-03-08 过期',
    key: 'oneYearPoint',
    show: () => dayjs().isBefore('2026-03-08', 'day'),
  },
  {
    name: '🥟 饺子原料',
    desc: '用于制作饺子，2026-03-08 过期',
    key: 'mooncakeMaterial',
    show: () => dayjs().isBefore('2026-03-08', 'day'),
  },
  {
    name: '📦 装备背包扩容',
    desc: '每份持有使装备背包容量 +10',
    key: 'itemCapacity',
  },
  {
    name: '📦 仓库扩容',
    desc: '每份持有使仓库容量 +10',
    key: 'warehouseCapacity',
  },
  {
    name: '📦 装备套路扩容',
    desc: '每份持有使背包装备套路 +1',
    key: 'equippedRoutine',
  },
  {
    name: '📦 魔物牧场扩容',
    desc: '每份持有使魔物牧场容量 +10',
    key: 'petCapacity',
  },
  {
    name: '📦 符石背包扩容',
    desc: '每份持有使符石背包容量 +10',
    key: 'runeCapacity',
  },
  {
    name: '📦 技能背包扩容',
    desc: '每份持有使技能背包容量 +10',
    key: 'skillCapacity',
  },
  {
    name: '🔋 月卡天数',
    desc: '剩余的月卡天数',
    key: 'monthlyCard',
    show: (value: number) => value > 0,
  },
]
